import { AllowanceTypes } from "@Shared/Entities/Supplier/Response/Proposal/enums";
export const oobPresenceConstraints = (hasUsage, covered) => Object.keys(AllowanceTypes).reduce((constraints, key) => {
    if (key === AllowanceTypes["UK IDD to Everywhere (mins)"]) {
        return constraints;
    }
    if (hasUsage) {
        const { used = 0 } = covered[key] || {};
        if (used === 0) {
            return constraints;
        }
    }
    constraints[key] = {
        presence: true,
    };
    return constraints;
}, {});
export const oobValidConstraints = (hasUsage, covered) => Object.keys(AllowanceTypes).reduce((constraints, key) => {
    if (key === AllowanceTypes["UK IDD to Everywhere (mins)"]) {
        return constraints;
    }
    if (hasUsage) {
        const { used = 0 } = covered[key] || {};
        if (used === 0) {
            return constraints;
        }
    }
    constraints[key] = {
        presence: true,
        type: "number",
    };
    return constraints;
}, {});
